import { mutate } from 'swr'

import {
  postJson,
  postJsonForBatch,
  putJson,
  requestDelete,
  requestDeleteBatchWithBody,
} from '../../../../data/fetchers'
import { RoleAssignmentDto } from './model'

// post role assignment
export async function requestPostRoleAssignment(
  dto: RoleAssignmentDto,
): Promise<any> {
  const result = await postJson('/selfservices/suppliers/roleassignments', dto)

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key
      .toLowerCase()
      .startsWith('/selfservices/suppliers/roleassignments'.toLowerCase()),
  )

  return result
}

// post role assignments
export async function requestPostRoleAssignments(
  dto: RoleAssignmentDto[],
): Promise<any> {
  const result = await postJsonForBatch(
    '/selfservices/suppliers/roleassignments/$batch',
    dto,
  )

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key
      .toLowerCase()
      .startsWith(
        '/selfservices/suppliers/roleassignments/$batch'.toLowerCase(),
      ),
  )

  return result
}

// put role assignment
export async function requestPutRoleAssignmentById(
  roleAssignmentId: string,
  dto: RoleAssignmentDto,
): Promise<any> {
  const result = await putJson(
    `/selfservices/suppliers/roleassignments/${roleAssignmentId}`,
    dto,
  )

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key
      .toLowerCase()
      .startsWith(
        `/selfservices/suppliers/roleassignments/${roleAssignmentId}`.toLowerCase(),
      ),
  )

  return result
}

// delete role assignment
export async function requestDeleteRoleAssignmentById(
  roleAssignmentId: string,
): Promise<any> {
  const result = await requestDelete(
    `/selfservices/suppliers/roleassignments/${roleAssignmentId}`,
  )

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key
      .toLowerCase()
      .startsWith(
        `/selfservices/suppliers/roleassignments/${roleAssignmentId}`.toLowerCase(),
      ),
  )

  return result
}

// delete role assignments
export async function requestDeleteRoleAssignments(
  roleAssignmentIds: string[],
): Promise<any> {
  const result = await requestDeleteBatchWithBody(
    `/selfservices/suppliers/roleassignments/$batch`,
    roleAssignmentIds,
  )

  // HACK: Should be called in components in order to make OptimisticUi possible
  mutate((key: string) =>
    key
      .toLowerCase()
      .startsWith(
        `/selfservices/suppliers/roleassignments/$batch`.toLowerCase(),
      ),
  )

  return result
}
